import { adminClient } from "better-auth/client/plugins"
import { organizationClient } from "better-auth/client/plugins"
import { createAuthClient } from "better-auth/react"
import { ac, roles } from "./permissions-client"

export const authClient = createAuthClient({
  // Use type assertions since our client-safe ac/roles are structurally compatible
  // but have different TypeScript types than better-auth's internal types.
  // The actual permission enforcement happens server-side; this is just for client hints.
  plugins: [
    organizationClient(),
    adminClient({ ac, roles } as unknown as Parameters<typeof adminClient>[0]),
  ],
})

export const { signIn, signOut, signUp, useSession } = authClient
